
import DashboardLayout from 'src/pages/Dashboard/Layout/DashboardLayout.vue';
import DefaultHeader from 'src/pages/Dashboard/DefaultHeader';

// common pages
import RichmenuSettings from 'src/pages/Stores/GeneralPages/RichmenuSettings.vue';
import ShopInfo from 'src/pages/Stores/GeneralPages/ShopInfo.vue';
import EditShopSettings from 'src/pages/Stores/GeneralPages/EditShopSettings.vue';
import CreateQrcodes from 'src/pages/Stores/GeneralPages/CreateQrcodes.vue';
import CreateShopWizard from 'src/pages/Stores/Gaa/CreateShopWizard.vue';
import EditOaSettings from 'src/pages/Stores/GeneralPages/EditOaSettings.vue';
import LineSpot from 'src/pages/Stores/GeneralPages/LineSpot.vue';
import LineModule from 'src/pages/Stores/GeneralPages/LineModule.vue';
import DeveloperTool from 'src/pages/Stores/GeneralPages/DeveloperTool.vue';
import CloudMarket from 'src/pages/Stores/GeneralPages/CloudMarket.vue';
import SearchMember from 'src/pages/Stores/GeneralPages/SearchMember.vue';

import OrderLimit from 'src/pages/Stores/GeneralPages/OrderLimit.vue';
import gacls from 'src/pages/Stores/GeneralPages/Acls.vue';

// gaa pages
import ShopList from 'src/pages/Stores/Gaa/ShopList.vue';
import contract from 'src/pages/Stores/Gaa/Contract.vue';
import Promotions from 'src/pages/Stores/Gaa/Promotions.vue';
import AccountSettingDefault from 'src/pages/Stores/Gaa/AccountSettingDefault.vue';

// si pages
import SiEditShopSettings from 'src/pages/Stores/Si/EditShopSettings.vue';

// eaa pages
import shops from 'src/pages/Stores/Eaa/Shops.vue';
import settings from 'src/pages/Stores/Eaa/Settings.vue';
import acls from 'src/pages/Stores/Eaa/Acls.vue';
import promotionIndex from 'src/pages/Stores/Eaa/Promotions/index.vue';
import promotionSetting from 'src/pages/Stores/Eaa/Promotions/Settings.vue';

import PrinterStation from 'src/pages/Stores/Gaa/PrinterStation.vue';

import NotAuthorized from '../pages/GeneralViews/NotAuthorized.vue';

const { createAuthGuard }  = require('./authGuard.js');

let printerStation  = {
  path: '/gaa/printer',
  component: DashboardLayout,
  children: [
    {
      path: 'stations',
      components: { default: PrinterStation, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
      props: {
        default: true
      }
    },
  ]
};
let shopConsole  = {
  // path: '/gaa/settings',
  // component: DashboardLayout,
  // children: [
  //   {
  //     path: '',
  //     components: { default: AccountSettingDefault, header: DefaultHeader },
  //     meta: { requiresAuth: true }, // 需驗證
  //     props: {
  //       default: true
  //     }
  //   },
  // ],
  path: '/:type/settings',
  component: DashboardLayout,
  children: [
    {
      path: '',
      components: { default: AccountSettingDefault, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
      props: {
        default: true
      }
    },
  ]
};

// const createAuthGuard = (externalType = null, idType = 'businessId') => {
//   return async (to, from, next) => {
//     const businessId = to.params.id;
//     const businessType = externalType || to.params.type; // 這裡做判斷

//     if (!businessId) {
//       next();
//       return;
//     }

//     console.log(`正在檢查授權：businessId = ${businessId}, businessType = ${businessType}`);

//     try {
//       if (businessType === 'gaa') {
//         next();
//         return;
//       }

//       const apiUrl = `${process.env.VUE_APP_APIHOST}/${businessType}/check-auth`
      
//       const response = await axios.post(apiUrl,  {
//         options: {
//           accountId: idType === 'accountId' ? businessId: undefined, 
//           businessId: idType === 'businessId' ? businessId: undefined,
//         }
//       });

//       const isAuthorized = response.data.authorized
//       if (isAuthorized) {
//         console.log('授權檢查通過！');
//         next();
//       } else {
//         console.warn('授權檢查失敗：找不到相符的 businessId');
//         // alert('授權檢查失敗：找不到相符的 businessId')
//         next({name: 'NotAuthorized'}); // 停留在原頁面
//       }
//     } catch (error) {
//       console.error('API 權限檢查失敗:', error);
//       next({name: 'NotAuthorized'}); // 停留在原頁面
//     }
//   };
// };

let c_commonPage = {
  path: '/:type/business',
  component: DashboardLayout,
  children: [
    {
      path: 'info/richmenu-settings',
      components: { default: RichmenuSettings, header: DefaultHeader },
      // component: info
      meta: { requiresAuth: false }, // 需驗證
    }, {
      path: ':id/info',
      components: { default: ShopInfo, header: DefaultHeader },
      // component: info
      meta: { requiresAuth: true }, // 需驗證
      beforeEnter: createAuthGuard()
    },
    {
      path: ':id/edit',
      components: { default: EditShopSettings, header: DefaultHeader },
      // component: edit
      meta: { requiresAuth: true }, // 需驗證
      beforeEnter: createAuthGuard()
    },
    {
      path: ':id/qr',
      components: { default: CreateQrcodes, header: DefaultHeader },
      // component: qrcode
      meta: { requiresAuth: true }, // 需驗證
      beforeEnter: createAuthGuard()
    },
    {
      path: ':id/promotion',
      components: { default: Promotions, header: DefaultHeader },
      // component: qrcode
      meta: { requiresAuth: true }, // 需驗證
      beforeEnter: createAuthGuard()
    },
    {
      path: ':id/update-oa',
      components: { default: EditOaSettings, header: DefaultHeader },
      // component: qrcode
      meta: { requiresAuth: true }, // 需驗證
      beforeEnter: createAuthGuard()
    },
    {
      path: 'line-spot',
      components: { default: LineSpot, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: ':id/order-limits',
      components: { default: OrderLimit, header: DefaultHeader },
      // component: wizard
      meta: { requiresAuth: true }, // 需驗證
      beforeEnter: createAuthGuard("accountId")
    },
    {
      path: ':id/acls',
      components: { default: gacls , header: DefaultHeader },
      // component: wizard
      meta: { requiresAuth: true }, // 需驗證
      beforeEnter: createAuthGuard("accountId")
    },
    {
        path: '/not-authorized',
        name: 'NotAuthorized',
        components: { default: NotAuthorized, header: DefaultHeader },
    },
  ]
}

let c_gaaPage = {
  path: '/gaa/business',
  component: DashboardLayout,
  children: [{
    path: '',
    components: { default: ShopList, header: DefaultHeader },
    // component: business
    meta: { requiresAuth: true }, // 需驗證
  },
  {
    path: 'wizard',
    components: { default: CreateShopWizard, header: DefaultHeader },
    // component: wizard
    meta: { requiresAuth: true }, // 需驗證
  },
  {
    path: ':id/contract',
    components: { default: contract, header: DefaultHeader },
    // component: wizard
    meta: { requiresAuth: true }, // 需驗證
  },
  ]
}

let c_siPage = {
  path: '/si/business',
  component: DashboardLayout,
  children: [{
    path: '',
    components: { default: SiEditShopSettings, header: DefaultHeader },
    // component: business
    meta: { requiresAuth: true }, // 需驗證
  }
  ]
}

let c_eaaPage = {
  path: '/eaa/business',
  component: DashboardLayout,
  children: [
    {
      path: 'shop-management',
      components: { default: shops, header: DefaultHeader },
      // component: settings
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'promotions',
      components: { default: promotionIndex, header: DefaultHeader },
      // component: settings
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: ':id/promotion-setting',
      components: { default: promotionSetting, header: DefaultHeader },
      // component: settings
      meta: { requiresAuth: true }, // 需驗證
      beforeEnter: createAuthGuard()
    },
    {
      path: ':id/settings',
      components: { default: settings, header: DefaultHeader },
      // component: settings
      meta: { requiresAuth: true }, // 需驗證
      beforeEnter: createAuthGuard()
    }
  ]
}

let otherPage = {
  path: '/other',
  component: DashboardLayout,
  children: [
    {
      path: 'line-spot',
      components: { default: LineSpot, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'line-module',
      components: { default: LineModule, header: DefaultHeader },
      // component: wizard
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'developer-tool',
      components: { default: DeveloperTool, header: DefaultHeader },
      // component: wizard
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'printer/stations',
      components: { default: PrinterStation, header: DefaultHeader },
      // component: wizard
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'cloud-market',
      components: { default: CloudMarket, header: DefaultHeader },
      // component: wizard
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'member',
      components: { default: SearchMember, header: DefaultHeader },
      // component: wizard
      meta: { requiresAuth: true }, // 需驗證
    },
  ]
}

export {
  c_gaaPage,
  // c_businessEdit,
  c_eaaPage,
  c_siPage,
  c_commonPage,
  otherPage,
  shopConsole,
  printerStation
};
